module.exports = __webpack_public_path__ + "img/watch-1.9416a07a.png";